import { RegisterUser } from '@app/core/models';
import { Component, OnInit, inject } from '@angular/core';
import { EnvironmentService } from 'src/app/core/environment.service';
import { TranslateModule } from '@ngx-translate/core';
import { TrackingDirective } from '@app/core/services/tracking/tracking.directive';
import { ContactUsButtonComponent } from '@app/shared/components/contact-us/contact-us-button/contact-us-button.component';
import { LogoComponent } from '@app/shared/components/logo/logo.component';

/**
 * Here's the expected data structure
 * `history.state.data = {
 *       callback: 'https://account.royalcanin.com',
 *       locale: 'fr_FR',
 *       profile: {
 *         firstName: 'Stéphane',
 *         lastName: 'Francel',
 *         email: 'sfrancel@yopmail.com',
 *         login: 'sfrancel@yopmail.com',
 *         locale: 'fr_FR',
 *         preferredLanguage: 'fr-FR',
 *         countryCode: 'FR'
 *       },
 *       credentials: {
 *         password: {
 *           value: '2020@Pazword'
 *         }
 *       }
 *     };`
 */
@Component({
  selector: 'app-register-page-success',
  templateUrl: './register-page-email-success.component.html',
  styleUrls: ['./register-page-email-success.component.scss'],
  imports: [
    TrackingDirective,
    TranslateModule,
    ContactUsButtonComponent,
    LogoComponent,
  ],
})
export class RegisterPageEmailSuccessComponent implements OnInit {
  private env = inject(EnvironmentService);

  user!: RegisterUser;

  ngOnInit(): void {
    if (history.state && history.state.data) {
      this.user = history.state.data;
    } else {
      window.location.href = this.env.getGlobalRedirectURI();
    }
  }
}
